import styled from 'styled-components'


const HeaderStyle = styled.header`
    padding:var(--sp4x) 0;

    .search {
        flex:1;
        margin: 0 var(--sp25x) 0 var(--sp6x) ;
        position: relative;

        .ant-form-item {
            margin-bottom: 0;

            input {
                padding-left: var(--sp6x);
            }
        }

        .op-search {
            font-size: var(--sp2-5x);
            position: absolute;
            top:50%;
            left:var(--sp2x);
            transform: translateY(-50%);
        }
    }

    .buttons-cont {
        position: relative;

        .settings-popup {
            position: absolute;
            top:100%;
            right:0;
            padding:var(--sp4x);
            border-radius:10px;
            background-color: var(--white);
            z-index: 3;
            pointer-events: none;
            opacity: 0;
            transition: var(--trTime);
            box-shadow: 0px 0px 10px 4px rgba(0, 0, 0, 0.1);
            
            &.active {
                pointer-events: all;
                opacity: 1;
            }
            
            a {
                transition: var(--trTime);
                display: block;
                
                @media screen and (min-width:1200px){
                    &:hover {
                        color:var(--purple);
                    }
                }

                &:last-child{
                    margin-top:var(--sp2x);
                }
            }
        }

        .op-ring {
            position: relative;

            &.active {

                &:after {
                    content: '';
                    position: absolute;
                    top:0;
                    right: 0;
                    width: var(--spSize);
                    height: var(--spSize);
                    border-radius: 50%;
                    background-color: var(--red);
                    border:2px solid var(--white);
                    box-sizing: content-box;
                }
            }
        }

        .avatar {
            width: var(--sp7x);
            height: var(--sp7x);
            position: relative;
            border:3px solid #F4F5F9;
            border-radius: 10px;
            margin-left: var(--sp4x);

            .imageCont {
                border:3px solid var(--white);
                position: absolute;
                top:0;
                left:0;
                width: 100%;
                height: 100%;
                border-radius: 10px;

                img {
                    border-radius: 6px;
                }
            }
        }

        i {
            font-size: var(--sp4x);
            margin-left:var(--sp2x);

            &:before {
                transition:var(--trTime);
            }
            
            &:hover {
                &:before {
                    color:var(--purple);
                }
            }
        }

        button {
            &:last-child {
                margin-left:var(--sp3x);
            }
        }
    }

    @media screen and (max-width:${(props) => props.theme.mediaQuery.TabletSize}){
        .search {
            margin: 0 var(--sp8x) 0 var(--sp4x) ;
        }
    }

    @media screen and (max-width:${(props) => props.theme.mediaQuery.TabletSizeS}){
        .search {
            margin: 0 0 0 var(--sp4x) ;
        }

        .buttons-cont {

            .avatar {
                margin-left: var(--sp2x);
            }
            
            i {
                margin-left:var(--sp1-5x);
            }
        }
    }

    @media screen and (max-width:${(props) => props.theme.mediaQuery.MobileSize}){
        section {
            position: relative;

                & > .op-search {
                font-size: var(--sp2x);
                background-color: var(--lightGrey);
                padding: 12px;
                border-radius: 8px;

                &:before {
                    color:var(--darkGrey);
                }
            }
        }

        .search {
            position: absolute;
            top:100%;
            left:0;
            width: 100%;
            margin:0;
            background-color: var(--white);
            z-index: 3;

            .ant-form-item {
                display: flex;
                align-items: center;
                padding:12px 0;
                margin:0 16px;

                input {
                    /* width: 100%; */
                    height: 100%;
                }
            }


            .op-search {
                top:50%;
                left:var(--sp4x);
                transform: translate(0%,-50%);
                background-color: transparent;
                font-size: var(--sp2x);
            }
            
            .op-close {
                font-size: var(--sp2x);
                margin-left:8px;
            }
        }

        .buttons-cont {
            .craete-debate {
                width: var(--sp4x);
                height: var(--sp4x);
                background-color:var(--purple);
                border-radius:50%;
                display: flex;
                align-items:center;
                justify-content:center;

                i {
                    font-size:var(--sp2x);
                    color:var(--white);
                    margin-left:0;
                }
            }

            .avatar {
                width: var(--sp5x);
                height: var(--sp5x);
                border-radius: 8px;
                margin-left: var(--sp2x);

                .imageCont {
                    border:2px solid var(--white);
                    border-radius: 8px;

                    img {
                        border-radius: 4px;
                    }
                }
            }

            /* i {
                display: none;
            } */
            
            button {
                &:last-child {
                    margin-left:var(--sp1-5x);
                }
            }
        }
    }
`
export default HeaderStyle
